// PopUp.ts

// Definição dos tipos para as chaves dos modais
type ModalKey = 'ShowFile' | 'ReturnResponse' | 'Confirmation' | 'InfGraffic' | 'UpdateSite' | 'ListVersion' | 'CreationTime' | 'ZoomMap' | 'GraphData';

// Tipo para callbacks de estado (boolean)
type ModalStateCallback = (state: boolean) => void;

// Tipo para callbacks de dados (any)
type ModalDataCallback = (data: any) => void;

// Interface para os estados dos modais
interface IModalState {
    ShowFile       : boolean;
    ReturnResponse : boolean;
    Confirmation   : boolean;
    InfGraffic     : boolean;
    UpdateSite     : boolean;
    ListVersion    : boolean;
    CreationTime   : boolean;
    ZoomMap        : boolean;
    GraphData      : boolean;
}

// Interface para os dados dos modais
interface IModalData {
    ShowFile       : any;
    ReturnResponse : any;
    Confirmation   : any;
    InfGraffic     : any;
    UpdateSite     : any;
    ListVersion    : any;
    CreationTime   : any;
    ZoomMap        : any;
    GraphData      : any;
}

// Interface para os observadores de estado
interface INotifyModalObserver {
    ShowFile       : ModalStateCallback[];
    ReturnResponse : ModalStateCallback[];
    Confirmation   : ModalStateCallback[];
    InfGraffic     : ModalStateCallback[];
    UpdateSite     : ModalStateCallback[];
    ListVersion    : ModalStateCallback[];
    CreationTime   : ModalStateCallback[];
    ZoomMap        : ModalStateCallback[];
    GraphData      : ModalStateCallback[];
}

// Interface para os observadores de dados
interface INotifyModalData {
    ShowFile       : ModalDataCallback[];
    ReturnResponse : ModalDataCallback[];
    Confirmation   : ModalDataCallback[];
    InfGraffic     : ModalDataCallback[];
    UpdateSite     : ModalDataCallback[];
    ListVersion    : ModalDataCallback[];
    CreationTime   : ModalDataCallback[];
    ZoomMap        : ModalDataCallback[];
    GraphData      : ModalDataCallback[];
}

const ModalState: IModalState = {
    ShowFile       : false,
    ReturnResponse : false,
    Confirmation   : false,
    InfGraffic     : false,
    UpdateSite     : false,
    ListVersion    : false,
    CreationTime   : false,
    ZoomMap        : false,
    GraphData      : false
};

const ModalData: IModalData = {
    ShowFile       : {},
    ReturnResponse : {},
    Confirmation   : {},
    InfGraffic     : {},
    UpdateSite     : {},
    ListVersion    : {},
    CreationTime   : {},
    ZoomMap        : {},
    GraphData      : {}
};

const NotifyModalObserver: INotifyModalObserver = {
    ShowFile       : [],
    ReturnResponse : [],
    Confirmation   : [],
    InfGraffic     : [],
    UpdateSite     : [],
    ListVersion    : [],
    CreationTime   : [],
    ZoomMap        : [],
    GraphData      : []
};

const NotifyModalData: INotifyModalData = {
    ShowFile       : [],
    ReturnResponse : [],
    Confirmation   : [],
    InfGraffic     : [],
    UpdateSite     : [],
    ListVersion    : [],
    CreationTime   : [],
    ZoomMap        : [],
    GraphData      : []
};

export function SetModalData(modal: ModalKey, data: any): void {
    ModalData[modal] = data;
    NotifyModalData[modal].forEach(element => {
        element(data);
    });
}

export function SetModalState(modal: ModalKey, state: boolean): void {
    ModalState[modal] = state;
    NotifyModalObserver[modal].forEach(element => {
        element(state);
    });
}

export function GetModalState(key: ModalKey, value: string): any {
    return ModalData[key][value];
}

export function GetModalData(key: ModalKey): any {
    return ModalData[key];
}

export function RegisterModalObserver(modal: ModalKey, callback: ModalStateCallback): void {
    NotifyModalObserver[modal].push(callback);
}

export function RegisterModalData(modal: ModalKey, callback: ModalDataCallback): void {
    NotifyModalData[modal].push(callback);
}